import React from "react";
import Header from "../Header";
import { Redirect } from "react-router-dom";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { fetchDistributions, deleteDistribution } from "../../../store/actions";
import { DISTRIBUTION_IMAGE_URL } from "../../../store/constants";
const distImgUrl = DISTRIBUTION_IMAGE_URL;
class DistributionsList extends React.Component {
  state = { redirect: false, redirectState: "" };
  componentDidMount() {
    this.props.fetchDistributions();
  }
  async delete(id) {
    await this.props.deleteDistribution(id, this.props.token);
    this.props.fetchDistributions();
  }
  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: this.state.redirect,
            state: this.state.redirectState,
          }}
        />
      );
    }
    return (
      <div>
        <Header />
        <Container className="mt-3">
          <Row className="mb-3">
            <Col sm={6} className="text-left">
              <h4>List of distributions</h4>
            </Col>
            <Col sm={6} className="text-right">
              <Button
                onClick={() =>
                  this.setState({ redirect: "/admin/distributions/new" })
                }
              >
                Add Distribution
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Icon</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.distributions.map((distribution) => {
                    return (
                      <tr key={distribution.id}>
                        <td>{distribution.id}</td>
                        <td>{distribution.title}</td>
                        <td>
                          <img
                            src={distImgUrl + distribution.icon}
                            width="40"
                            height="40"
                            alt={distribution.title}
                          />
                        </td>

                        <td>
                          &nbsp;&nbsp;
                          <Button
                            variant="danger"
                            onClick={() => this.delete(distribution.id)}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  token: state.access_token,
  distributions: state.distributions,
});
const mapDispatchToProps = { fetchDistributions, deleteDistribution };
export default connect(mapStateToProps, mapDispatchToProps)(DistributionsList);
